export default function Equals(): React.ReactElement {
  return <span className="text-purple font-semibold text-md sm:text-lg">&nbsp;=&nbsp;</span>
}
